import { dataLayerPush } from '@/core/features/tracking/google-data-layer';

export function trackActivityTilesClick(title: string) {
    dataLayerPush({
        activity: title,
        element: 'activity_tile',
        event: 'click',
    });
}
